import "babel-polyfill";
import "@fortawesome/fontawesome-free/css/all.css";
import "font-awesome/css/font-awesome.css";
import Vue from "vue";
import Vuetify from "vuetify";
import "./plugins/vuetify";
import "./plugins/vue-auth";
import "./plugins/filters";
import 'video.js/dist/video-js.css'
import App from "./App.vue";
import router from "./router/";
import store from "./store";
import "./registerServiceWorker";
import firebase from "firebase/app";
import moment from "moment";
import vuetify from "@/plugins/vuetify";
import VueTheMask from "vue-the-mask";
import VueObserveVisibility from "vue-observe-visibility";
import VueQrcode from "@chenfengyuan/vue-qrcode";

Vue.use(VueObserveVisibility);
Vue.use(VueTheMask);
Vue.component(VueQrcode.name, VueQrcode);

Vue.use(Vuetify, {
  iconfont: "fa"
});

Vue.config.productionTip = false;

const config = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINSENDERID,
  appId: process.env.VUE_APP_FIREBASE_APPID
};

firebase.initializeApp(config);

window.OneSignal = window.OneSignal || [];
window.OneSignal.push(() => {
  window.OneSignal.init({
    appId: process.env.VUE_APP_ONESIGNAL,
    allowLocalhostAsSecureOrigin: process.env.NODE_ENV !== 'production',
  });
});

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
